module.exports = ".btn-quar{\n    min-width: 10%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/quarantine/quarantine.component.css
// module id = ./src/app/quarantine/quarantine.component.css
// module chunks = main